import api from './api';

const supportMessagesApi = {
  list: () => api.get('/support/messages'),
  answer: (id) => api.post(`/support/messages/${id}/answer`)
};

export default supportMessagesApi;
